/**
 * Onboarding tour status — tied to the user account so the tour only auto-prompts
 * once across devices (not per-browser).
 */

import { API_ENDPOINTS } from '../config/api';
import { makeAuthenticatedRequest } from './apiService';

export const getTourStatus = async (): Promise<boolean> => {
  const res = await makeAuthenticatedRequest(API_ENDPOINTS.USERS.TOUR_STATUS);
  if (!res.ok) throw new Error('Failed to fetch tour status');
  const data = await res.json();
  return data.completed === true;
};

export const markTourCompleted = async (): Promise<void> => {
  // Best-effort; the UI shouldn't break if this fails.
  await makeAuthenticatedRequest(API_ENDPOINTS.USERS.TOUR_COMPLETED, { method: 'POST' });
};
